import type { TOC } from '@ember/component/template-only'
import type Student from 'teacher-ui-client/models/student'
import { LoginCard } from 'teacher-ui-client/components/login-card'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { t } from 'ember-intl'

interface Args {
  teacherName: string
  schoolName: string
  students: Student[] | null
  subscriptionType: SubscriptionType
}
interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export const LoginCardsPage: TOC<Signature> = <template>
  {{! Page designed to fit 2x3 login cards in portrait for A4 and US Letter paper sizes }}
  {{! A4 portrait size (210mm (w) x 297mm (h)) }}
  {{! US Letter (8.5in (h) x 11in (w) OR 215.9mm (w) x 279.4mm (h)) }}
  {{! Can't use grid or flex, as page break inside avoid doesn't work for those }}
  <div ...attributes>
    <p class="mb-3">{{@teacherName}} - {{t "pages.loginCards.title"}}</p>
    <p class="mb-3">{{@schoolName}}</p>
    {{! Avoids inline gaps, without needing to use flex or grid }}
    {{#each @students as |student|}}<LoginCard
        {{! These are sized to be like a business card }}
        {{! To get a 2x3, these sizes assume a maximum of 8mm print page margin (16mm both sides) }}
        {{! 8 + 96 + 96 + 8 === 208mm }}
        data-test-login-card
        class="h-[84mm] w-[96mm] break-inside-avoid"
        @subscriptionType={{@subscriptionType}}
        @student={{student}}
      />{{/each}}
  </div>
</template>

export default LoginCardsPage
